import './style.scss'

export default {
  name: 'RichText',
  props: ['content'],
  render (h) {
    return (
      <div domPropsInnerHTML={this.content} class='RichText' />
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/RichText/index.js